import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Form from "@/v2-backoffice-client/components/form"

export type BulkFormProps = ComponentProps<typeof Form>

function BulkForm(props: BulkFormProps) {
  const { className, ...formProps } = props
  return <Form className={cn("bulk-form", className)} {...formProps} />
}

export default BulkForm
